"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReminderStatus = void 0;
var ReminderStatus;
(function (ReminderStatus) {
    ReminderStatus["PENDING"] = "PENDING";
    ReminderStatus["WAITING"] = "WAITING";
    ReminderStatus["COMPLETE"] = "COMPLETE";
})(ReminderStatus = exports.ReminderStatus || (exports.ReminderStatus = {}));
